export type ColorValue = keyof typeof colorValues;

export const colorValues = {
  // Primary light
  $green100: "#EDF9E1",
  $green150: "#D3E6BE",
  $green200: "#B8E682",
  $green300: "#76C82E",
  $green400: "#178000",
  $green500: "#003004",

  // Primary hover
  $green450: "#157300",

  // Primary dark
  $dGreen100: "#18361A",
  $dGreen150: "#264A26",
  $dGreen200: "#184A18",
  $dGreen250: "#7DC440",
  $dGreen300: "#6FBD2B",
  $dGreen400: "#A2C777",
  $dGreen500: "#D0E8B5",

  // Secondary
  $amber100: "#FFF6D7",
  $amber150: "#F5DBA5",
  $amber200: "#FFDE9B",
  $amber300: "#FEA628",
  $amber400: "#BD500C",
  $amber500: "#551903",

  // Secondary dark
  $dAmber100: "#3D180B",
  $dAmber200: "#82452A",
  $dAmber300: "#D18E2E",
  $dAmber400: "#E5BB70",
  $dAmber500: "#FAE8BB",

  // Accent
  $indigo100: "#F1F4FF",
  $indigo150: "#C8CCF5",
  $indigo200: "#BEC4FF",
  $indigo300: "#600AFF",
  $indigo400: "#3B0AAF",
  $indigo500: "#14035E",

  // Accent dark
  $dIndigo100: "#211B47",
  $dIndigo200: "#484599",
  $dIndigo300: "#5430B8",
  $dIndigo400: "#A7ADE5",
  $dIndigo500: "#D6DFFA",

  // Beige
  $beige100: "#F8F6F3",
  $beige150: "#F5F3F0",
  $beige200: "#EEEBE8",
  $beige300: "#E4E1DD",
  $beige400: "#DBD6D1",
  $beige500: "#938E8A",

  // Brown
  $brown100: "#E5D4CA",

  // Brown dark
  $dBrown100: "#3D312B",

  // Gray
  $gray100: "#4F4C4A",
  $gray200: "#292724",
  $gray300: "#22201C",
  $gray400: "#1A1815",
  $gray500: "#12100D",

  // Red
  $red100: "#F0CCD1",
  $red400: "#B50019",
  $red500: "#A30017",

  // Red dark
  $dRed300: "#F53649",
  $dRed400: "#D42A3B",
  $dRed500: "#B92736",

  // White
  $whiteish: "#F7F7F7",
  $white: "#FFFFFF",
  ["$white8%"]: "rgba(255, 255, 255, 0.08)",
  ["$white23%"]: "rgba(255, 255, 255, 0.23)",
  ["$white50%"]: "rgba(255, 255, 255, 0.50)",
  ["$white65%"]: "rgba(255, 255, 255, 0.65)",

  // Black
  $blackish: "#212121",
  $black: "#000000",
  ["$black4%"]: "rgba(0, 0, 0, 0.04)",
  ["$black6%"]: "rgba(0, 0, 0, 0.06)",
  ["$black8%"]: "rgba(0, 0, 0, 0.08)",
  ["$black23%"]: "rgba(0, 0, 0, 0.23)",
  ["$black50%"]: "rgba(0, 0, 0, 0.50)",
  ["$black65%"]: "rgba(0, 0, 0, 0.65)",

  // Kivra Extra
  $kvxSand100: "#EAE8DA",
  $kvxSand200: "#D9CFA9",
  $kvxGradient01: "linear-gradient(120deg, #E2CE9D, #AEBCA1)",

  // Kivra Extra dark
  $dKvxSand100: "#1C2117",
  $dKvxSand200: "#2B3621",
  $dKvxGradient01: "linear-gradient(120deg, #4D401D, #33422B)",
};
